import { alert, alertPopup } from "@/slices/alert/AlertReducer";
import { store } from "@/store";

export const alertShow = (alert: alert) => store.dispatch(alertPopup({ alert: alert }));
